import { render, staticRenderFns } from "./ClientQuotes.vue?vue&type=template&id=00cf6b02&"
import script from "./ClientQuotes.vue?vue&type=script&lang=ts&"
export * from "./ClientQuotes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports